import {ACTION_CODE} from './_actionCode';
import {TrainingAttachementService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_TRAINING_ATTACHMENT';

export async function createTrainingAttachment(
    userData: Record<string, string>,
    newTrainingAttachment: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - createTrainingAttachment - Start');

        const createTrainingAttachmentResult = await TrainingAttachementService.createTrainingAttachment(userData, newTrainingAttachment);

        LoggerService.logInfo('Action - createTrainingAttachment - End - Success');

        return ResultModel.newSuccessResult(createTrainingAttachmentResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createTrainingAttachment - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
